import React from 'react'
import PropTypes from 'prop-types'

import * as GridUtils from './GridUtils'

export default class EntryGuidance extends React.Component {
  render () {
    const msg = this.props.message.replace('\\n', '\n').split('\n').map(function (m, i) { return (<span key={i}>{m}<br /></span>) })
    return (
      <div className='EntryGuidance' id={this.props.id} style={Object.assign(GridUtils.GridPosStyle(this.props.row, this.props.col), this.props.style)}>
        {msg}
      </div>
    )
  }
}

EntryGuidance.propTypes = {
  row: PropTypes.number.isRequired,
  col: PropTypes.number.isRequired,
  message: PropTypes.string.isRequired,
  id: PropTypes.string,
  style: PropTypes.object
}

EntryGuidance.defaultProps = {
  id: '',
  style: {}
}



// WEBPACK FOOTER //
// ./src/EntryGuidance.js